module.exports = __webpack_public_path__ + "img/2.c48989ca.jpg";